import { MenuContent } from './MenuContent';

// TODO: in v9, move styled() from MenuContent.jsx to here
export var StyledMenuContent = MenuContent;